<template>
  <sri-chart :value="adaptedProduct"></sri-chart>
</template>

<script>
// "Profilo di rischio" (RiskProfile). Uses components/ProductDetails/SriChart.vue
// (prop-driven only — no Vuex/parent coupling) for the Highcharts column-histogram + IndicatorBoxes.
//
// SriChart.vue expects a `value` shaped like a Product (`.structure`, `.sriMin`, `.sriMax`,
// `.sriDistribution`), not this page's RiskProfilePayload (`{ min, max, distribution }`) — this
// adapter is the only translation needed. `structure` is inferred from `distribution`'s presence
// (2/Mop when set, 1/Sop otherwise) since RiskProfilePayload itself carries no structureType — see
// backend RiskProfileSectionBuilder/DistributionSri.BuildFrom, which already only ever sets
// `distribution` for a MOP-shaped product, so this inference is exact, not a guess.
import SriChart from '../../ProductDetails/SriChart'

export default {
  name: 'risk-profile-section',
  components: {
    SriChart,
  },
  props: {
    payload: { type: Object, required: true },
  },
  computed: {
    adaptedProduct() {
      return {
        structure: this.payload.distribution != null ? 2 : 1,
        sriMin: this.payload.min,
        sriMax: this.payload.max,
        sriDistribution: this.payload.distribution,
      }
    },
  },
}
</script>
